module.exports = __webpack_public_path__ + "img/robot_icon.f170e75.png";